<template>
<div id="login" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- <h1 style="text-align: center">英语单词后台管理系统</h1> -->
    <div :style="bstyle">
        <el-card>
            <div slot="header" style="text-align: center">
                <span>用户激活</span>
            </div>
            <el-form :model="ruleForm" status-icon  ref="ruleForm" label-width="auto"
                     label-position="left">
                <el-form-item label=""  prop="password">
                    <el-input placeholder="请输入密码" show-password type="password" maxlength=30 v-model="ruleForm.password1" autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item label=""  prop="password">
                    <el-input placeholder="请再次输入密码" show-password type="password" maxlength=30 v-model="ruleForm.password2" autocomplete="off" ></el-input>
                </el-form-item>
                <el-form-item style="text-align: right">
                    <el-button type="primary" @click="confirm">确 认</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    name : 'login',
    props : {

    },
    data() {
        return{
            bstyle: {
                top: '0px',
                bottom: '0px',
                left: '0px',
                right: '0px',
                position: 'fixed',
                width: '400px',
                height: '400px',
                margin: "auto auto"
            },
            fullscreenLoading : false,
            ruleForm: {
                password1: '',
                password2: ''
            },
            activateToken : ''
        }
    },
    mounted : function(){
        this.activateToken = this.$route.query.activateToken;
        if(this.activateToken == undefined){
            this.$router.replace({name:"login"});
        }
    },
    methods : {
        confirm(){
            if(this.ruleForm.password1.length == 0){
                this.$message("请输入密码");
                return;
            }
            if(this.ruleForm.password2.length == 0){
                this.$message("请再次输入密码");
                return;
            }
            if(this.ruleForm.password1 == this.ruleForm.password2){
                if(this.ruleForm.password1.length < 6){
                    this.$message("密码长度需要：>=6");
                    return;
                }
                let _this = this;
                _this.request("POST","/noauth/activate",{
                    activateToken : this.activateToken,
                    password : this.ruleForm.password1,
                    type : "public"
                },function(data){
                    _this.request("POST","/auth/login",{
                        type : 'public',
                        username : data,
                        password : _this.ruleForm.password1
                    },function(data){
                        localStorage.setItem("stoken",data.token);
                        localStorage.setItem("srefreshToken",data.token);
                        _this.$router.replace({name : 'index'});
                    })
                });
            }else{
                this.$message("密码不一致");
            }
            
        }
    }
}
</script>

<style>

</style>